import { ANIMATED_FILE_EXTENSIONS, ANIMATED_MIME_TYPES, VIDEO_FILE_EXTENSIONS, VIDEO_MIME_TYPES } from '../constants'
import { CreationToolSourceInfo } from '../types'

const getUrlExtension = (url: string): string => {
    if (url.indexOf('youtube.com') > -1 || url.indexOf('youtu.be') > -1) {
        return 'youtube'
    }

    if (url.indexOf('vimeo.com') > -1) {
        return 'vimeo'
    }

    return `.${url
        .split('?')[0]
        .split('.')
        .pop()}`
}

const getSourceInfo = (source: File | string): CreationToolSourceInfo => {
    const isUrl = typeof source === 'string'
    const fileType = isUrl ? getUrlExtension(source as string) : (source as File).type
    const isVideo = isUrl ? VIDEO_FILE_EXTENSIONS.indexOf(fileType) > -1 : VIDEO_MIME_TYPES.indexOf(fileType) > -1
    const isAnimated = isUrl
        ? ANIMATED_FILE_EXTENSIONS.indexOf(fileType) > -1
        : ANIMATED_MIME_TYPES.indexOf(fileType) > -1

    return {
        isUrl,
        isVideo,
        isAnimated,
    }
}

export default getSourceInfo
